import { isTestEnvironment } from './environment-utils'

// NOTE
// Environment variables must be accessed using `process.env.MY_ENV_VAR` syntax.
// This is because webpack will replace `process.env.MY_ENV_VAR` with the actual value at build time.
// If you try to access env vars using `process.env['MY_ENV_VAR']`, it will always be `undefined`.

// ---------- EXPOSED CLIENT SIDE ----------
// Any env var that is prefixed with NEXT_PUBLIC_ will be exposed client side.

export function getBffBaseUrl(): string {
  return requiredEnvVar(process.env.NEXT_PUBLIC_BFF_API_URL, 'NEXT_PUBLIC_BFF_API_URL')
}

export function getHydraBaseUrl(): string {
  return requiredEnvVar(process.env.NEXT_PUBLIC_HYDRA, 'NEXT_PUBLIC_HYDRA')
}

export function getAnimationServiceBaseUrl(): string {
  return requiredEnvVar(process.env.NEXT_PUBLIC_ANIMATION_SERVICE_URL, 'NEXT_PUBLIC_ANIMATION_SERVICE_URL')
}

/**
 * Returns the Recurly public key if present. This key is used client-side by RecurlyProvider.
 * We do not throw here to allow callers to gate rendering gracefully when the key is absent in certain environments.
 */
export function getRecurlyPublicKey(): string | undefined {
  return process.env.NEXT_PUBLIC_RECURLY_PUBLIC_KEY
}

// ---------- SERVER SIDE ONLY ----------

export function getOauth2IssuerBaseUrl(): string {
  return requiredEnvVar(process.env.OAUTH2_ISSUER_BASE_URL, 'OAUTH2_ISSUER_BASE_URL')
}

export function getOauth2ClientId(): string {
  return requiredEnvVar(process.env.OAUTH2_CLIENT_ID, 'OAUTH2_CLIENT_ID')
}

export function getOauth2ClientSecret(): string {
  return requiredEnvVar(process.env.OAUTH2_CLIENT_SECRET, 'OAUTH2_CLIENT_SECRET')
}

export function getOauth2Audience(): string {
  return requiredEnvVar(process.env.OAUTH2_AUDIENCE, 'OAUTH2_AUDIENCE')
}

export function getOauth2ValidationUrl(): string {
  return requiredEnvVar(process.env.OAUTH2_VALIDATION_URL, 'OAUTH2_VALIDATION_URL')
}

// ----- UTILS -----

function requiredEnvVar(value: string | undefined, keyName: string): string {
  if (typeof value === 'string') return value
  if (isTestEnvironment()) return keyName
  throw new Error(`A required env var is missing: "${keyName}"`)
}
